/** @format */

import {OauthProvider} from 'graphql/generated/types';

export const STATS_PROVIDERS: OauthProvider[] = ['METRIKA', 'WEBDAV'];
